"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetupCardItem = exports.SetupCardButton = exports.SetupCard = exports.SetupCardHeader = void 0;
const react_1 = __importStar(require("react"));
const SetupCard_pc_1 = require("./SetupCard.pc");
exports.SetupCardHeader = SetupCard_pc_1.SetupCardHeader;
const SetupCard = ({ children }) => {
    return react_1.default.createElement(SetupCard_pc_1.SetupCard, null, children);
};
exports.SetupCard = SetupCard;
exports.SetupCardButton = SetupCard_pc_1.ButtonCardItem;
const SetupCardItem = ({ title, subtitle, active: activeOverride, children, complete, iconText, iconButton, transparent, lockReason, hidden, v2, dismissable, ignoreClick, show, testId, onClick: onClickOverride, onDismissableClick, }) => {
    const [active, setActive] = (0, react_1.useState)(false);
    const onClick = () => {
        if (!lockReason && ignoreClick !== true) {
            setActive(!active);
        }
        onClickOverride && onClickOverride();
    };
    return (react_1.default.createElement(SetupCard_pc_1.SetupCardItem, { onClick: onClick, iconText: iconText, iconButton: iconButton, active: activeOverride || active, title: title, subtitle: subtitle, transparent: transparent, complete: complete, lockedReason: lockReason, testId: testId, hidden: hidden, dismissable: dismissable, show: show, v2: v2, onDismissableClick: onDismissableClick }, children));
};
exports.SetupCardItem = SetupCardItem;
//# sourceMappingURL=SetupCard.js.map